import React, { useContext, useState, useEffect } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useLocation, useNavigate } from 'react-router-dom';
import FormPermissionService from "../../Setup/controller/FormPermissionController/FormPermissionController";
import CreatePartPage from "./PartForms/CreatePart";
import UpdateNotesPage from "./PartForms/UpdateNotes";
import UpdateFinancialPage from "./PartForms/UpdateFinancial";
import UpdateImagePage from "./PartForms/UpdateImage";
import SupplierStockPage from "./PartForms/SupplierStockList";
import StockDiscountListPage from "./PartForms/StockDiscountList";
import StockBatchListPage from "./PartForms/StockBatchList";
import BOMPartListPage from "./PartForms/BOMPartList";
import Draggable from 'react-draggable';
import JobsListPage from "../../Jobs/View/JobsList";
import PartService from "../Controller/PartController";
import StockReportPage from "./PartForms/StockReport";
import PartUserDefineFields from "./PartForms/PartUserDefineFields";
import PartNotesListPage from "./PartForms/PartNotesList";
import StockSerialTrackingPage from "./PartForms/StockSerialTracking";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import HelpSite from "../../Common/HelpLink";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
};
function PartsDetail({ StockID, onClose, onSuccess }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/AdministrationSetting";
    //  FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [tabCount, setTabCount] = useState(0);
    const [activeTab, setActiveTab] = useState("tab-customer");
    const [isMinimized, setIsMinimized] = useState(false);
    const [partName, setPartName] = useState("Part Details");
    const [isSerialTracking, setIsSerialTracking] = useState("0");
    const [isBatchManagement, setBatchManagement] = useState("0");
    const [isLock, setIsLock] = useState(0);
    const UserID = localStorage.getItem("UserID");
    const [assignedModules, setAssignedModules] = useState(new Set());
    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    useEffect(() => {
        if (StockID > 0) {
            fetchPartDetail();
            fetchAssignedModules();
        } else {
            setIsSerialTracking("0");
            setPartName("Part Details");
        }
    }, [StockID]);
    const fetchPartDetail = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const PartID = StockID;

            if (PartID > 0) {
                const SupplierDetail = await PartService.GetPartByID(redirectCallback, PartID);
                setPartName(SupplierDetail[0].vc_StockName);
                setIsSerialTracking(SupplierDetail[0].snt_SerialTracking);
                setBatchManagement(SupplierDetail[0].bit_BatchManagement);

                if (SupplierDetail[0].isLock === 1 && SupplierDetail[0].LockBy != UserID) {
                    setIsLock(1);
                }
                else {
                    setIsLock(0);
                    await PartService.LockPart(PartID);
                }
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const changeTab = (tab) => {
        setActiveTab(tab);
        handleTabClick(); // Increment count
    };
    const handleTabClick = () => {
        setTabCount(prevCount => prevCount + 1); // Increment the count when any tab is clicked
    };
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };
    const tabClass = (StockID > 0) ? "nav-link" : "nav-link disabled";
    return (


        <div className="modal fade partPopupModal show d-block" id="partPopupModal" tabIndex="-1" aria-labelledby="partPopupModalLabel" aria-hidden="true" data-backdrop="static">
            <div className="modal-dialog modal-xl">
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{partName} <strong style={{ fontSize: "14px", color: "red" }}> {isLock.toString() === "0" ? "" : "(Locked)"}</strong></h5>
                            <span>
                                <button type="button" className="close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize">
                                    <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                </button>

                            </span>
                        </div>
                        {!isMinimized && (
                            <div className="modal-body" style={{ flex: "1" }}>
                                <div className="row vertical-pills-tab">
                                    <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: "20px", marginRight: "25px", width: "100%", background: "#fff", borderBottom: "1px solid #d8e0e3" }}>
                                        <ul className="nav nav-tabs" style={{ border: "none", borderColor: "none" }}>
                                            <li className="nav-item">
                                                <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-customer' ? 'active' : ''}`} data-toggle="pill" href="#tab-customer" onClick={() => changeTab('tab-customer')}>
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/part_details.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Part</strong>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-sites' ? 'active' : ''}`} data-toggle="pill" href="#tab-sites" onClick={() => changeTab('tab-sites')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_images-and-attributes.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                            {"Images& Attributes".split(" ").map((word, i) => (
                                                                <span key={i} className="top-word">
                                                                    {word}
                                                                </span>
                                                            ))}
                                                        </strong>
                                                        </div></a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_images-and-attributes.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Details</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-contacts' ? 'active' : ''}`} data-toggle="pill" href="#tab-contacts" onClick={() => changeTab('tab-contacts')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_financials.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Financials</strong>
                                                        </div></a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_financials.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Financials</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-discounting' ? 'active' : ''}`} data-toggle="pill" href="#tab-discounting" onClick={() => changeTab('tab-discounting')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_bill-of-materials.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>BOM</strong>
                                                        </div></a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_bill-of-materials.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>BOM</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-costs' ? 'active' : ''}`} data-toggle="pill" href="#tab-costs" onClick={() => changeTab('tab-costs')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_notes.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Notes</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_notes.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Notes</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {assignedModules.has(MODULE_IDS.Suppliers) && parseInt(isLock) === 0 ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-jobs' ? 'active' : ''}`} data-toggle="pill" href="#tab-jobs" onClick={() => changeTab('tab-jobs')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_suppliers.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Suppliers</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_suppliers.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Suppliers</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            {/* {isLock.toString() === "0" ? (
                                                <a className={tabClass} data-toggle="pill" href="#tab-userDefineFields">User Define Fields</a>
                                            ) : (
                                                <a className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                    User Define Fields
                                                </a>
                                            )}*/}
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-quotation' ? 'active' : ''}`} data-toggle="pill" href="#tab-quotation" onClick={() => changeTab('tab-quotation')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_discounts.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Discounts</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_discounts.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Discounts</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {assignedModules.has(MODULE_IDS.Jobs) && parseInt(isLock) === 0 && (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-activity' ? 'active' : ''}`} data-toggle="pill" href="#tab-activity" onClick={() => changeTab('tab-activity')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/part_activity.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Activity</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {((isBatchManagement === "1" || isBatchManagement === 1) &&
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-batches' ? 'active' : ''}`} data-toggle="pill" href="#tab-batches" onClick={() => changeTab('tab-batches')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/opp_details.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Batches</strong>
                                                        </div>
                                                    </a>

                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {((isSerialTracking === "2" || isSerialTracking === 2) &&
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-serial' ? 'active' : ''}`} data-toggle="pill" href="#tab-serial" onClick={() => changeTab('tab-serial')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/opp_details.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Serial No.</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            

                                        </ul>
                                        <div className="ml-auto">
                                            {activeTab === "tab-customer" && (
                                                <HelpSite FormName="Part" Module="5" />
                                            )}
                                            {activeTab === "tab-sites" && (
                                                <HelpSite FormName="Images and Attributes" Module="5" />
                                            )}
                                            {activeTab === "tab-contacts" && (
                                                <HelpSite FormName="Financials" Module="5" />
                                            )}
                                            {activeTab === "tab-discounting" && (
                                                <HelpSite FormName="BOM" Module="5" />
                                            )}
                                            {activeTab === "tab-costs" && (
                                                <HelpSite FormName="Notes" Module="5" />
                                            )}
                                            {activeTab === "tab-jobs" && (
                                               <HelpSite FormName="Supplier" Module="5" />
                                            )}
                                            {activeTab === "tab-userDefineFields" && (
                                               <HelpSite FormName="User Define Fields" Module="5" />
                                            )}
                                            {activeTab === "tab-quotation" && (
                                                <HelpSite FormName="Discount" Module="5" />
                                            )}
                                            {activeTab === "tab-activity" && (
                                                 <HelpSite FormName="Part Activities" Module="5" />
                                            )}
                                            {activeTab === "tab-batches" && (
                                                <HelpSite FormName="Batches" Module="5" />
                                            )}
                                            {activeTab === "tab-serial" && (
                                               <HelpSite FormName="Financials" Module="5" />
                                            )}
                                            {activeTab === "tab-reports" && (
                                                <HelpSite FormName="Report" Module="3" />
                                            )}
                                        </div>

                                    </div>

                                    <div className="col-sm-12 pl-0">
                                        <div className="tab-content p-3" id="v-pills-tabContent">
                                            <div className={`tab-pane fade ${activeTab === 'tab-customer' ? 'show active' : ''}`} id="tab-customer" role="tabpanel">
                                                <CreatePartPage StockID={parseInt(StockID, 10)} Tab={tabCount} isLock={isLock} onClose={onClose} />
                                            </div>
                                            {StockID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-sites' ? 'show active' : ''}`} id="tab-sites" role="tabpanel">
                                                    <UpdateImagePage StockID={parseInt(StockID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {StockID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-contacts' ? 'show active' : ''}`} id="tab-contacts" role="tabpanel">
                                                    <UpdateFinancialPage StockID={parseInt(StockID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {StockID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-discounting' ? 'show active' : ''}`} id="tab-discounting" role="tabpanel">
                                                    <BOMPartListPage StockID={parseInt(StockID, 10)} Tab={tabCount} isLock={isLock} />
                                                </div>
                                            )}
                                            {StockID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-costs' ? 'show active' : ''}`} id="tab-costs" role="tabpanel">
                                                    <PartNotesListPage StockID={parseInt(StockID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {StockID > 0 && assignedModules.has(MODULE_IDS.Suppliers) && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-jobs' ? 'show active' : ''}`} id="tab-jobs" role="tabpanel">
                                                    <SupplierStockPage StockID={parseInt(StockID, 10)} isLock={isLock} />
                                                </div>
                                            )}

                                            {StockID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-userDefineFields' ? 'show active' : ''}`} id="tab-userDefineFields" role="tabpanel">
                                                    <PartUserDefineFields StockID={parseInt(StockID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {StockID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-quotation' ? 'show active' : ''}`} id="tab-quotation" role="tabpanel">
                                                    <StockDiscountListPage StockID={parseInt(StockID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {StockID > 0 && assignedModules.has(MODULE_IDS.Jobs) && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-activity' ? 'show active' : ''}`} id="tab-activity" role="tabpanel">
                                                    <JobsListPage CustomerID={parseInt("0")} AssetID={parseInt("0")} StockID={parseInt(StockID, 10)} ContractID={parseInt("0")} isLock={isLock} />
                                                </div>
                                            )}
                                            {StockID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-batches' ? 'show active' : ''}`} id="tab-batches" role="tabpanel">
                                                    <StockBatchListPage StockID={parseInt(StockID, 10)} Tab={tabCount} isLock={isLock} />
                                                </div>
                                            )}
                                            {StockID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-serial' ? 'show active' : ''}`} id="tab-serial" role="tabpanel">
                                                    <StockSerialTrackingPage StockID={parseInt(StockID, 10)} Tab={tabCount} isLock={isLock} />
                                                </div>
                                            )}
                                            {StockID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-reports' ? 'show active' : ''}`} id="tab-reports" role="tabpanel">
                                                    <StockReportPage StockID={parseInt(StockID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default PartsDetail;
